export interface FaqItem {
  title: string,
  content: string,
  listItems?: string[]
}